import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PlanSetting } from '../plan-setting.model';
import { PlanSettingActions, PlanSettingActionTypes } from '../actions/plan-setting.actions';

export interface State extends EntityState<PlanSetting> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<PlanSetting> = createEntityAdapter<PlanSetting>({
  selectId: model => model.Id ?? model.id ?? `${model.Package}_${model.Level}_${model.PlanName}`
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: PlanSettingActions
): State {
  switch (action.type) {
    case PlanSettingActionTypes.AddPlanSetting: {
      return adapter.addOne(action.payload.planSetting, state);
    }

    case PlanSettingActionTypes.UpsertPlanSetting: {
      return adapter.upsertOne(action.payload.planSetting, state);
    }

    case PlanSettingActionTypes.AddPlanSettings: {
      return adapter.addMany(action.payload.planSettings, state);
    }

    case PlanSettingActionTypes.UpsertPlanSettings: {
      return adapter.upsertMany(action.payload.planSettings, state);
    }

    case PlanSettingActionTypes.UpdatePlanSetting: {
      return adapter.updateOne(action.payload.planSetting, state);
    }

    case PlanSettingActionTypes.UpdatePlanSettings: {
      return adapter.updateMany(action.payload.planSettings, state);
    }

    case PlanSettingActionTypes.DeletePlanSetting: {
      return adapter.removeOne(action.payload.id, state);
    }

    case PlanSettingActionTypes.DeletePlanSettings: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case PlanSettingActionTypes.LoadPlanSettings: {
      return adapter.setAll(action.payload.planSettings, {...state, Loaded: true, Loading: false});
    }

    case PlanSettingActionTypes.ClearPlanSettings: {
      return adapter.removeAll(state);
    }

    case PlanSettingActionTypes.GetPlanSettings: {
      return {...state, Loaded: false, Loading: true};
    }

    case PlanSettingActionTypes.GetUpdatePlanSettings: {
      return {...state, Loaded: false, Loading: true};
    }

    case PlanSettingActionTypes.GetPlanSettingsFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case PlanSettingActionTypes.ActivatePlanKey: {
      return {...state, Loaded: false, Loading: true};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
